import './trix'